import { UserWorkspaceProductsSlice } from 'features/user/types/user'
import { WorkspaceProductSlice } from '../types'

export const updateWorkspaceProducts = (
  workspaceProduct: WorkspaceProductSlice,
  userWorkspaceProducts: UserWorkspaceProductsSlice[],
): UserWorkspaceProductsSlice[] =>
  userWorkspaceProducts.map(
    (userWorkspaceProduct: UserWorkspaceProductsSlice): UserWorkspaceProductsSlice =>
      userWorkspaceProduct.product === workspaceProduct.product
        ? { ...userWorkspaceProduct, status: workspaceProduct.status }
        : userWorkspaceProduct,
  )
